<div class="d-flex flex-column gap-3 description-container">
    <span>
        <div class="d-flex gap-3 mb-3" [ngClass]="{'enlarge' : highlight()}">
            <div class="icon" [innerHTML]="currentDescriptionItem.icon"></div>
            <img class="cad-icon" *ngIf="currentDescriptionItem.cadIcon" [src]="currentDescriptionItem.cadIcon" alt="">
        </div>
        @if(showDescription()){
        <p class="description" [ngClass]="{'highlight' : highlight()}">{{currentDescriptionItem.content}}</p>
        <p *ngIf="currentDescriptionItem.subContent" class="description" [ngClass]="{'highlight' : highlight()}">
            {{currentDescriptionItem.subContent}}</p>
        }
        @if(showBulletPoints()){
        <ul class="bullets">
            <li *ngFor="let item of currentDescriptionItem.bulletPoints">{{item}}</li>
        </ul>
        }
        <!-- @if(reverseView()){
        <div class="d-flex gap-3">
            <div class="icon" [innerHTML]="currentDescriptionItem.icon"></div>
            <img class="cad-icon" *ngIf="currentDescriptionItem.cadIcon" [src]="currentDescriptionItem.cadIcon" alt="">
        </div>
        } -->
    </span>
</div>